import React, { useEffect, useState } from "react";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import { adminApi } from "@/lib/adminApi";

export default function AdminApp() {
    // null = checking, true = logged in, false = not logged in
    const [authed, setAuthed] = useState(null);

    const check = async () => {
        if (!adminApi.getToken()) {
            setAuthed(false);
            return;
        }
        try {
            await adminApi.me();
            setAuthed(true);
        } catch {
            setAuthed(false);
        }
    };

    useEffect(() => {
        // eslint-disable-next-line
        check();
    }, []);

    if (authed === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-zinc-500">
                Lade…
            </div>
        );
    }
    if (!authed) {
        return <AdminLogin onLogin={() => setAuthed(true)} />;
    }
    return <AdminDashboard onLogout={() => setAuthed(false)} />;
}
